const ITEMS = [
  "A THOUSAND YEARS OF VELVET AND GOLD",
  "FROM THE HIGHLANDS OF ETHIOPIA",
  "TO THE COASTS OF ERITREA",
  "HAND-THREADED GOLD EMBROIDERY",
  "THE HABESHA KABA",
  "HONOUR YOU CAN WEAR",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="heritage-marquee"
      className="overflow-hidden border-y border-gold/15 bg-ink2 py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-gold/45"
              >
                <span className="px-8">{item}</span>
                <span className="text-gold/30">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
